<div class="text-wrapper" matTooltip="{{toolTip}}">
  <ng-content #tooltipTpl></ng-content>
</div>
